import {CheckCircleFilled as AntdCheckCircleFilled} from '@ant-design/icons';

export default function CheckCircleFilled(props) {
  return <AntdCheckCircleFilled {...props} />;
}
